import { Link as LinkIcon } from 'almanac-ui/icons'
import { InlineFormatButton } from 'components/InlineFormatBar/components/InlineFormatButton/InlineFormatButton'
import { schema } from 'prose-core'
import { type EditorView } from 'prosemirror-view'
import type React from 'react'

export type TurnIntoLinkButtonProps = {
  view: EditorView
  callback?: () => void
  overrideSelectionRange?: { from: number; to: number }
}

export const TurnIntoLinkButton: React.FC<React.PropsWithChildren<TurnIntoLinkButtonProps>> = ({ view }) => {
  const { to } = view.state.selection
  const node = view.state.doc.nodeAt(view.state.selection.$from.pos)

  if (!node) return null

  const turnIntoLink = () => {
    if (!node) {
      return
    }
    const {
      selection: { from },
    } = view.state
    const link = node.attrs.link ?? node.attrs.url
    const newTo = from + link.length + 1
    const { tr } = view.state
    tr.delete(from, to)
    tr.insertText(link)
    tr.addMark(
      from,
      newTo,
      schema.marks.link.create({
        ...node.attrs,
        href: link,
        rel: 'noopener noreferrer ugc',
        target: '_blank',
      }),
    )
    tr.scrollIntoView()
    view.dispatch(tr)
  }

  return (
    <InlineFormatButton
      isDisabled={!view.editable}
      onClick={turnIntoLink}
      data-testid="turn-into-link-button"
      label="Turn into link"
    >
      <LinkIcon />
    </InlineFormatButton>
  )
}
